/**
 * カート周り
 */
const shippingDateUpdate = () => {
  const sippingDate = document.querySelector('#sippingDate');
  const sippingTime = document.querySelector('#sippingTime');
  const box = document.querySelectorAll('[name="attributes[宅配ボックス]"]');
  if (localStorage.getItem("shippingDate")) {
    sippingDate.querySelectorAll('option').forEach((e) => {
      if (e.value == localStorage.getItem("shippingDate")) {
        e.selected = true;
      }
    });
  }
  if (localStorage.getItem("sipping-time")) {
    
    sippingTime.querySelectorAll('option').forEach((e) => {
      if (e.value == localStorage.getItem("sipping-time")) {
        e.selected = true;
      }
    });
  }
  if (localStorage.getItem("delivery_box")) {
    box.forEach((e) => {
      if (e.dataset.deliveryType == localStorage.getItem("delivery_box")) {
        e.checked = true;
      }
    });
  }
  sippingDate.addEventListener('change', function () {
    const v = sippingDate.value;
    localStorage.setItem('shippingDate', v);
  }, 200);
  function fnRemoveLocalStorage() {
    localStorage.removeItem('shippingDate');
  }
  sippingTime.addEventListener('change', function () {
    const v = sippingTime.value;
    localStorage.setItem('sipping-time', v);
  }, 200);
  function fnRemoveLocalStorage1() {
    localStorage.removeItem('sipping-time');
  }
  for(let b of box) {
    b.addEventListener('change', function () {
    const v = b.dataset.deliveryType;
    localStorage.setItem('delivery_box', v);
  }, 200);
  }
}

const MikihouseCart = {
init: () => {
const elm = {
  'cartLineItems': document.querySelector('#cartLineItems'),
  'cartFormBtn': document.querySelector('#toCheckout'),
  'cartForm': document.querySelector('#cartForm'),
}
document.querySelector('.cart__footer').classList.remove('hide')
const lineItems = JSON.parse(elm.cartLineItems.textContent)
const loginFlg = elm.cartForm.dataset.customerLogin
const openBtn = document.querySelector('#giftwrap-link-btn a')
const modal = document.querySelector('#gift-setting-modaal')
const addBtn = document.querySelector('#add-gift-wrap')
// アラートの確認
MikihouseCart.maxPurchases.paramsChecker()
// 商品の数量を変更した際の制御
MikihouseCart.quantityChange.cartQuantityChange(lineItems)
// 商品の最大数の変更
MikihouseCart.maxPurchases.cartItemMaxPurchases(lineItems)
// 商品の同時購入不可制御
MikihouseCart.cannotPurchasedSomeTime.cannotPurchasedSameTime(lineItems)
// 商品削除
MikihouseCart.cartActions.cartItemRemove()
// ノベルティ商品削除
MikihouseCart.novelty.cartNoveltyItemRemove()
// 手数料商品のみまたはギフトラッピング希望商品がない場合の制御
MikihouseCart.cartActions.commissionItemOnly(lineItems)
// 手数料商品の数量が多かった場合
MikihouseCart.cartActions.commissionItemQuantity(lineItems)
// ギフトラッピング
MikihouseCart.giftWrapping.MikihouseGiftWrapping(lineItems, openBtn, modal, addBtn)
// 名入れ手数料商品追加
MikihouseCart.InsertName.MikihouseInsertNameCommission(lineItems)
// アウトレット商品に対する制御
MikihouseCart.outletItem.cartOutletItem(lineItems, loginFlg)
// 強制ラッピングにラッピングのプロパティがついていなかった場合の処理追加
MikihouseCart.giftWrapping.forcedGiftWrapping(lineItems)
MikihouseCart.messageCardOnly(lineItems)
// ギフトラッピングエラー
const query2 = new URLSearchParams(window.location.search);
if(query2.get('giftWrapping') != null) {

  /**
   * TODO: 多言語対応
   */
   const language = {
    ja: {
      error: 'ギフトラッピング設定を変更する必要があります。お手数をおかけいたしますがギフトラッピングの設定を再度お願いいたします。'
    },
    en: {
      error: 'There is a problem with your gift-wrapped item. We apologize for the inconvenience, but please set up the gift wrapping again.'
    },
    ko: {
      error: '선물 포장 상품에 문제가 있습니다. 번거로우시겠지만 선물 포장 설정을 다시 한번 부탁드립니다.'
    },
    'zh-CN': {
      error: '礼物包装的产品有一个问题。 请再次设置礼物包装。'
    },
    'zh-TW': {
      error: '我對禮品包裝商品有疑問。對於給您帶來的不便，我們深表歉意，但請重新設置禮品包裝。'
    }
  }
  alert(`${language[Shopify.locale].error}`)
  document.querySelector('.cart__footer .cart__buttons-container').remove()
  const url = new URL(window.location)
  url.searchParams.delete('giftWrapping')
  history.pushState({}, '', url)
}
// カートのフォーム送信
if(elm.cartFormBtn) {
  elm.cartFormBtn.addEventListener('click', (e) => MikihouseCart.cartActions.cartSubmitAction(e, lineItems))
}
},
messageCardOnly: async (lineItems) => {
const messageCard = lineItems.filter(e => e.tags.includes('メッセージカード'))
const giftWrapping = lineItems.filter(e => e.tags.includes('ギフトラッピング商品'))
const giftTargetProduct = lineItems.filter(e => {
  if(e?.properties) {
    for(let key in e.properties) {
      if (e.properties[key]) {
        return e.properties[key].includes('ギフトラッピング')
      }
    }
  }
})
if(messageCard.length === 0) {
  return
}
if(messageCard.length > 0 && giftTargetProduct.length === 0) {
  const update = {
    'updates': {
      [messageCard[0].key]: 0
    }
  }
  const add = {
    'items': []
  }

  for(let index in giftTargetProduct) {
    update.updates[giftTargetProduct[index].key] = 0
    let prop = {}
    for(let p in giftTargetProduct[index]?.properties) {
      prop = {}
      if(giftTargetProduct[index].properties[p].includes('ギフトラッピング')) continue
      prop[giftTargetProduct[index].properties[p][0]] = giftTargetProduct[index].properties[p][1]
    } 
    add.items.push({
      id: giftTargetProduct[index].variant_id,
      quantity: giftTargetProduct[index].quantity,
      properties: prop
    })
  }
  const url = window.Shopify.routes.root + 'cart/update.js'

  const headers = {
    'method': 'POST',
    'headers': {
      'Content-Type': 'application/json'
    },
    'body': JSON.stringify(update)
  }
  await MikihouseCart.cartActions.fetchCart(url, headers)
  MikihouseCart.cartActions.cartAdd(add, true)      
}
},
cannotPurchasedSomeTime: {
cannotPurchasedSameTime: (lineItems) => {
  let result = true

  for(let i = 0; i < lineItems.length; i++) {
    if(lineItems[i].metafields.cannot_purchased_same_time_flg == true) {
      result = MikihouseCart.cannotPurchasedSomeTime.cannotPurchasedSameTimeCheck(lineItems, lineItems[i].product_id)
    }
    if(result == false) {
      break
    }
  }
  /**
   * 多言語対応
   */
   const language = {
    ja: {
      error: '同時に購入できない商品がカートに含まれております。'
    },
    en: {
      error: 'The cart contains items that cannot be purchased at the same time.'
    },
    ko: {
      error: '동시에 구매할 수 없는 상품이 장바구니에 포함되어 있습니다.'
    },
    'zh-CN': {
      error: '购物车包含不能同时购买的产品。'
    },
    'zh-TW': {
      error: '購物車包含不能同時購買的項目。'
    }
  }
  if(result == false) {
    const target = document.querySelector('#errorModal')
    document.querySelector('#errorModal > div.content > div').innerHTML = `<p>${language[Shopify.locale].error}</p>`
    target.classList.remove('hide')
    document.querySelector('#errorModal .close-btn').addEventListener('click', () => target.classList.add('hide'))
    document.querySelector('#errorModal .bg').addEventListener('click', () => target.classList.add('hide'))
  }
},
cannotPurchasedSameTimeCheck: (lineItems, product_id) => {
  for(let i = 0; i < lineItems.length; i++) {
    if(lineItems[i].type != '手数料商品' && lineItems[i].tags.includes('ノベルティ商品') == false) {
      if(lineItems[i].product_id != product_id && lineItems[i].handle != '14-9992-578') {
        return false
      }
    }
  }
  return true
},
},
cartActions: {
cartAdd: async (items, sections) => {
  let query = ''
  if(sections) {
    query = '?sections=cart-template,header'
  }
  const url = window.Shopify.routes.root + 'cart/add.js' + query
  const headers = {
    'method': 'POST',
    'headers': {
      'Content-Type': 'application/json'
    },
    'body': JSON.stringify(items)
  }
  const result = await MikihouseCart.cartActions.fetchCart(url, headers)
  return result
},
cartItemRemove: () => {
  const target = document.querySelectorAll('.remove-btn')
  for(let i = 0; i < target.length; i++) {
    target[i].addEventListener('click', (e) => MikihouseCart.cartActions.cartUpdate(e.target.dataset.removeId, 0, e.target.dataset.removeTarget))
  }
},
cartItemsRemove: (sections) => {
  let query = ''
  let result
  if(sections) {
    query = '?sections=cart-template,header'
  }
  const url = window.Shopify.routes.root + 'cart/clear.js' + query
  const headers = {}
  MikihouseCart.cartActions.fetchCart(url, headers)
},
cartSubmitAction: async (e, lineItems) => {
  MikihouseCart.cartActions.cartSubmitFunctions()
  .then((res) => {
    if(res == true) {
      document.querySelector('#cartForm [name="checkout"]').click()
    }
  })
},
cartSubmitFunctions: () => {
  return new Promise(async (resolve) => {
    const target = document.querySelectorAll('.noveltycollection-input')
    if(target.length > 0) {
      const novelty = await MikihouseCart.novelty.noveltyAddToCart()
    }
    const expectedShipment = await MikihouseCart.shippingDate.expectedShipmentDate()
    const orderLimit = await MikihouseCart.orderDateSet.orderDate()
    resolve(true) 
  })
},
cartUpdate: (id, qty, key = false) => {
  const priceField = document.querySelector(`tr[data-cart-item-key="${key}"] span[data-cart-item-regular-price]`)
  const loadingImg = document.querySelector('#loading-gif')
  priceField.innerHTML = loadingImg.innerHTML
  if(key) {
    id = key
  }
  const variantId = id
  const value = qty
  const url = window.Shopify.routes.root + 'cart/update.js?sections=cart-template,header'
  const body = {
    'updates': {}
  }
  body['updates'][variantId] = value
  const headers = {
    'method': 'POST',
    'headers': {
      'Content-Type': 'application/json'
    },
    'body': JSON.stringify(body)
  }
  MikihouseCart.cartActions.fetchCart(url, headers)
},
commissionItemOnly: (lineItems) => {
  let wrappingFlg = false
  let messageFlg = false
  let wrappingTarget = false
  let wrappingDeleteIds = {
    'updates': {}
  }
  let commissionItemFlg = false
  for(let i = 0; i < lineItems.length; i++) {
    if(lineItems[i].type == '手数料商品') {
      commissionItemFlg = true
    }
  }
  for(let i = 0; i < lineItems.length; i++) {
    if(lineItems[i].type != '手数料商品') {
      commissionItemFlg = false
    }
  }
  // ギフトラッピング希望商品がなかった場合に削除ロジック
  if(commissionItemFlg == false) {
    MikihouseCart.giftWrapping.giftWrappingRemoveAction(lineItems, wrappingFlg, messageFlg, wrappingDeleteIds, wrappingTarget)
  }
  // 手数料商品の削除
  if(commissionItemFlg == true) {
    MikihouseCart.cartActions.cartItemsRemove(true)
  }
},
fetchCart: (endpoint, headers, checkoutFlg = false) => {
  const btn = document.querySelector('#toCheckout')
  if(btn) {
    btn.style.display = 'none'
  }
  return new Promise((resolve, reject) => {
    fetch(endpoint, headers)
    .then(response => response.json())
    .then(res => {
      if(res.sections) {
        if (checkoutFlg) {
            MikihouseCart.cartActions.sectionUpdate(res.sections['cart-template'], '#shopify-section-cart-template table')
            // MikihouseCart.cartActions.sectionUpdate(res.sections['cart-template'], '#shopify-section-cart-template .cart-novelty')
            MikihouseCart.cartActions.sectionUpdate(res.sections['cart-template'], '#shopify-section-cart-template #gift-setting-modaal')
            MikihouseCart.cartActions.sectionUpdate(res.sections['cart-template'], '#shopify-section-cart-template .cart__footer', checkoutFlg)
            MikihouseCart.cartActions.sectionUpdate(res.sections['header'], '#CartCount', checkoutFlg)
          } else {
            MikihouseCart.cartActions.sectionUpdate(res.sections['header'], '#CartCount')
            MikihouseCart.cartActions.sectionUpdate(res.sections['cart-template'], '#shopify-section-cart-template')
          }
      }
      if(btn) {
        btn.style.display = 'block'
      }
      resolve(res)
    })
    .catch(error => console.error(error))
  })
},
sectionUpdate: (section, target, checkoutFlg=false) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(section, 'text/html');
  const element = doc.querySelector(target)
  if (checkoutFlg) {
    document.querySelector('#shopify-section-cart-template .cart__footer #toCheckout').classList.add('hide')
  }
  document.querySelector(target).innerHTML = element.innerHTML
  if(target === '#shopify-section-cart-template' && checkoutFlg == false) {
    MikihouseCart.init()
  }
  shippingDateUpdate()
},
commissionItemQuantity: (lineItems) => {
  const commissionItemList = lineItems.filter(e => e.type === '手数料商品')
  let commissionItemOver = false
  const url = window.Shopify.routes.root + 'cart/update.js?sections=cart-template,header'
  const body = {
    'updates': {}
  }
  for(let i = 0; i < commissionItemList.length; i++) {
    if(commissionItemList[i].quantity > 1) {
      commissionItemOver = true
    }
  }
  if(commissionItemOver == true) {
    for(let i = 0; i < commissionItemList.length; i++) {
      body['updates'][commissionItemList[i].variant_id] = 1
    }
    const headers = {
      'method': 'POST',
      'headers': {
        'Content-Type': 'application/json'
      },
      'body': JSON.stringify(body)
    }
  }
}
},
giftWrapping: {
forcedGiftWrapping: (lineItems) => {
  for(let i = 0; i < lineItems.length; i++) {
    if(lineItems[i].metafields.wrapping.wrapping_type === '99') {
      // let test = lineItems[i].properties.filter(e => {
      //   return e[0] === 'ギフトラッピング'
      // })
      let regex = /ギフトラッピング/g
      let result = regex.test(JSON.stringify(lineItems[i].properties));
      if(result === false) {
        let body = {
          'line': i + 1,
          'properties': {
            'ギフトラッピング': 'ラッピングあり'
          }
        }
        const url = window.Shopify.routes.root + 'cart/change.js?sections=cart-template,header'
        const headers = {
          'method': 'POST',
          'headers': {
            'Content-Type': 'application/json'
          },
          'body': JSON.stringify(body)
        }
        MikihouseCart.cartActions.fetchCart(url, headers)
      }
    }
  }
},
cartGiftWrappingAddToCart: async (target, lineItems) => {
  const selector = document.querySelector('input[name="giftwrapping"]:checked')
  const gift = document.querySelectorAll('input.gift-wrap-input.gift-wrap-input-wrappable:checked')
  const addedGift = document.querySelectorAll('input.gift-wrap-input.gift-wrap-input-wrapped:checked')
  let checkFlg = false
  if(selector.getAttribute('id') != 'no-gift-wrapping') {
    for(let ii = 0;ii < gift.length;ii++) {
      if(gift[ii].checked == true) {
        checkFlg = true
      }
    }
    for(let ii = 0;ii < addedGift.length;ii++) {
      if(addedGift[ii].checked == true) {
        checkFlg = true
      }
    }
  }

  /**
   * TODO: 多言語対応
   */
  const language = {
    ja: {
      error: 'ギフトラッピングが選択されていません。',
      update: 'カート内商品更新中'
    },
    en: {
      error: 'Gift wrapping has not been selected.',
      update: 'Updating items in cart'
    },
    ko: {
      error: '선물 포장이 선택되지 않았습니다.',
      update: '장바구니 상품 업데이트 중'
    },
    'zh-CN': {
      error: '没有选择礼品包装。',
      update: '购物车中的产品正在更新'
    },
    'zh-TW': {
      error: '未選擇禮品包裝。',
      update: '更新購物車中的項目'
    }
  }
  if(checkFlg == false && selector.getAttribute('id') != 'no-gift-wrapping') {
    const target = document.querySelector('#errorModal')
    document.querySelector('#errorModal > div.content > div').innerHTML = `<p>${language[Shopify.locale].error}</p>`
    target.classList.remove('hide')
    document.querySelector('#errorModal .close-btn').addEventListener('click', () => target.classList.add('hide'))
    document.querySelector('#errorModal .bg').addEventListener('click', () => target.classList.add('hide'))
    return true
  }

  target.innerText = `${language[Shopify.locale].update}`
  const setItems = document.querySelectorAll('.giftwrapping-item input.gift-wrap-input')
  let giftWrappingItem = []
  let noGiftWrappingItem = []
  let targetIds = []
  let noTargetIds = []
  let baseIdSort = []
  // ギフトラッピングをセットしたかどうかの判定
  for(let i = 0; i < setItems.length; i++) {        
    const json = MikihouseCart.giftWrapping.giftWrappingJson(giftWrappingItem, setItems[i], targetIds, setItems[i].checked, noTargetIds, noGiftWrappingItem, i, lineItems)
    giftWrappingItem = json.giftWrappingItem
    noGiftWrappingItem = json.noGiftWrappingItem
    targetIds = json.targetIds
    noTargetIds = json.noTargetIds
    baseIdSort = json.baseIdSort
  }
  // ギフトラッピングをセットした商品とセットしなかった商品をマージ
  giftWrappingItem = giftWrappingItem.concat(noGiftWrappingItem)
  // 順番をソート
  giftWrappingItem = giftWrappingItem.sort((a, b) => {
    if( a.index > b.index ) return -1;
    if( a.index < b.index ) return 1;
    return 0;
  });
  // ギフトラッピングをセットした商品があるか判定
  const giftFlg = MikihouseCart.giftWrapping.itemCheck(lineItems, targetIds)
  if(giftFlg === true) {
    giftWrappingItem = MikihouseCart.giftWrapping.giftItem(giftWrappingItem)
    giftWrappingItem = MikihouseCart.giftWrapping.message(giftWrappingItem)
  }
  const items = {
    'items': giftWrappingItem
  }
  // エラー用にバックアップを作成
  const backup = {
    items: []
  }
  for(let i = 0; i < lineItems.length; i++) {    
    const bkItem = {
      id: lineItems[i].id,
      quantity: lineItems[i].quantity,
      properties: lineItems[i].properties
    }    
    backup.items.unshift(bkItem)
  }
  await MikihouseCart.giftWrapping.giftWrappingClearItems()
  .then(async res => {  
    document.body.classList.remove('fixed')  
    const result = await MikihouseCart.cartActions.cartAdd(items, true)
    // もしエラーの場合には元に戻す
    if(result?.status) {
      MikihouseCart.cartActions.cartAdd(backup, true)
    }
    if(Shopify.locale != 'ja') {
      location.reload(true)
    }
    window.scrollTo(0,0);
  })
},
cartGiftWrappingOpen: (target, modal) => {
  let y = window.pageYOffset;
  document.body.classList.add('fixed')
  document.body.style.top = '-' + y + 'px'
  target.classList.toggle('open')
  if(target.classList.contains('open')) {
    modal.style.display = 'block'
  } else {
    modal.style.display = 'none'
    document.body.classList.remove('fixed')
  }
},
giftItem: (giftWrappingItem) => {
  const giftWrapping1 = document.querySelectorAll('.gift-wrap-input.gift-wrap-input-wrappable:checked')
  const giftWrapping2 = document.querySelectorAll('.gift-wrap-input.gift-wrap-input-wrapped:checked')
  if(giftWrapping1.length == 0 && giftWrapping2.length > 0 ) {
    return giftWrappingItem
  }
  const giftWrapping = document.querySelector('input[name="giftwrapping"]:checked')
  if(giftWrapping.getAttribute('id') != 'no-gift-wrapping') {
    const item = {
      'id': giftWrapping.value,
      'quantity': 1
    }
    giftWrappingItem.unshift(item)
  }
  return giftWrappingItem
},
MikihouseGiftWrapping: (lineItems, openBtn, modal, addBtn) => {
  if(openBtn) {
    openBtn.addEventListener('click', (e) => MikihouseCart.giftWrapping.cartGiftWrappingOpen(e.target, modal))
    const selector = document.querySelectorAll('input[name="giftwrapping"]')
    const gift = document.querySelectorAll('input.gift-wrap-input.gift-wrap-input-wrappable')
    const message = document.querySelector('#no-gift-card')
    const el = document.querySelector('#gift-wrapping-content')
    for(let i = 0; i < selector.length; i++) {
      selector[i].addEventListener('change', (e) => {
        if(e.target.getAttribute('id') == 'no-gift-wrapping') {
          MIKIHOUSE.slideToggle(el, 500);
          for(let ii = 0; ii < gift.length; ii++) {
            gift[ii].checked = false
          }
          message.checked = true
        } else {
          if(el.style.display == 'none') {
            MIKIHOUSE.slideToggle(el, 500);
            for(let ii = 0; ii < gift.length; ii++) {
              gift[ii].checked = true
            }
            message.checked = true
          }
        }
      })
    }
  }
  addBtn.addEventListener('click', (e) => MikihouseCart.giftWrapping.cartGiftWrappingAddToCart(e.target,lineItems))
},
giftWrappingClearItems: () => {
  return new Promise((resolve, reject) => {
    fetch(window.Shopify.routes.root + 'cart/clear.js')
    .then(response => response.json())
    .then(res => resolve(res))
    .catch(error => reject(error))
  })
},
itemCheck: (lineItems, targetIds) => {
  let wrappingFlg = true
  for(let i = 0; i < lineItems.length; i++) {
    let wrappingType;
    const target = targetIds.find(e => e === lineItems[i].id)
    if(target) {
      wrappingType = lineItems[i].metafields.wrapping.wrapping_type
    }
    if(wrappingType == '99') {
      wrappingFlg = true
    } else if(wrappingType == '1') {
      wrappingFlg = false
    } else {
      wrappingFlg = true
      break
    }
  }
  return wrappingFlg
},
giftWrappingJson: (giftWrappingItem, setItem, targetIds, checked, noTargetIds, noGiftWrappingItem, index, lineItems) => {
  const targetId = targetIds.some(e => e === Number(setItem.dataset.variant))
  const noTargetId = noTargetIds.includes(Number(setItem.dataset.variant))
  const targetItem = lineItems.filter(e => e.key === setItem.dataset.key)
  if(checked == true) {
    if(targetId != false) {
      for(let i = 0; i < giftWrappingItem.length; i++) {        
        if(giftWrappingItem[i].id === setItem.dataset.variant) {
          giftWrappingItem[i].quantity++
        }
      }
    } else {
      const obj = new Object
      if(targetItem[0].properties) {
        for (i = 0; targetItem[0].properties[i]; i++) {
          const k = targetItem[0].properties[i][0];
          const v = targetItem[0].properties[i][1];
          obj[k] = v;
        }
      }
      obj['ギフトラッピング'] = 'ラッピングあり'
      const item = {
        'id': setItem.dataset.variant,
        'quantity': 1,
        'properties': obj,
        'gift_type': setItem.classList.contains('gift-wrap-input-wrappable') ? '99' : '0',
        'index': index
      }

      if(targetItem.length > 0 && targetItem[0].properties) {
        for(let i = 0; i < targetItem[0].properties.length; i++) {
          item.properties[targetItem[0].properties[i][0]] = targetItem[0].properties[i][1]
        }
      }
      targetIds.push(Number(setItem.dataset.variant))
      giftWrappingItem.unshift(item)
    }
  }
  if(checked == false) {
    if(noTargetId != false) {
      for(let i = 0; i < noGiftWrappingItem.length; i++) {        
        if(noGiftWrappingItem[i].id === setItem.dataset.variant) {
          noGiftWrappingItem[i].quantity++
        }
      }
    } else {
      const obj = new Object
      if(targetItem[0].properties) {
        for (i = 0; targetItem[0].properties[i]; i++) {
          // 数量表示した際のエラー対応 20230616 kanehori
          if (!targetItem[0]?.properties[i]) break
          if(targetItem[0].properties[i][0] == 'ギフトラッピング') continue
          const k = targetItem[0].properties[i][0];
          const v = targetItem[0].properties[i][1];
          obj[k] = v;
        }
      }
      
      const item = {
        'id': setItem.dataset.variant,
        'quantity': 1,
        'properties': obj,
        'index': index
      }
      noTargetIds.push(Number(setItem.dataset.variant))
      noGiftWrappingItem.unshift(item)
    }
  }
  return {
    'giftWrappingItem': giftWrappingItem,
    'noGiftWrappingItem': noGiftWrappingItem,
    'targetIds': targetIds,
    'noTargetIds': noTargetIds,
  }
},
giftWrappingRemoveAction: async (lineItems, wrappingFlg, messageFlg, wrappingDeleteIds, wrappingTarget) => {
  const normalItems = lineItems.filter(e => !String(e.tags).match(/ギフトラッピング商品/) && !String(e.tags).match(/メッセージカード/));
  const giftTargetItems = normalItems.filter(e => e.properties && e.properties.some(item => item.includes('ギフトラッピング')));
  const forceGiftWrappingItemOnly = !giftTargetItems.some(e => e.metafields.wrapping.wrapping_type !== '99');

  const giftWrappingItems = lineItems.filter(e => String(e.tags).match(/ギフトラッピング商品/));
  const giftWrappingIds = giftWrappingItems.map(e => e.id);

  const messageCardItems = lineItems.filter(e => String(e.tags).match(/メッセージカード/));
  const messageCardIds = messageCardItems.map(e => e.id);

  if(!giftTargetItems.length) {
    // カート内にギフトラッピング対象商品がない時
    giftWrappingIds.forEach(id => wrappingDeleteIds.updates[id] = 0);
    messageCardIds.forEach(id => wrappingDeleteIds.updates[id] = 0);
    wrappingTarget = false;
    
  } else {
    // カート内にギフトラッピング対象商品がある時
    if(forceGiftWrappingItemOnly) {
      // 強制ラッピング商品のみ
      giftWrappingIds.forEach(id => wrappingDeleteIds.updates[id] = 0);
      wrappingTarget = false;

    } else {
      // 強制ラッピング以外でギフトラッピング設定をしている商品がある時
      wrappingDeleteIds.updates = {};
      wrappingTarget = true;
    }
  }

  if(wrappingTarget == false && Object.keys(wrappingDeleteIds.updates)?.length > 0) {
    const url = window.Shopify.routes.root + 'cart/update.js?sections=cart-template,header'
    const headers = {
      'method': 'POST',
      'headers': {
        'Content-Type': 'application/json'
      },
      'body': JSON.stringify(wrappingDeleteIds)
    }
    const result = await MikihouseCart.cartActions.fetchCart(url, headers)
    return result
  }
},
message: (giftWrappingItem) => {
  const messageCard = document.querySelectorAll('input[name="messagecard"]')
  for(let i = 0; i < messageCard.length; i++) {
    if(messageCard[i].checked == true && messageCard[i].value != '00000') {
      const card = {
        'id': messageCard[i].value,
        'quantity': 1
      }
      giftWrappingItem.unshift(card)
    } 
  }
  return giftWrappingItem
}
},
maxPurchases: {
cartItemMaxPurchases: (lineItems) => {
  let qtyCheck = true
  let variantId, qty, key, max;
  let outOfStock = true
  if(lineItems.length > 0) {
    for(let i = 0; i < lineItems.length; i++) {
      if(lineItems[i].inventory_management == '' || lineItems[i].inventory_policy == 'continue') {
        outOfStock = false
        max_purchases = 100000 // ここは注文できない数字にしてあります
      }
      if(lineItems[i].variant_metafields.max_purchases) {
        qtyCheck = MikihouseCart.maxPurchases.qtyChecker(lineItems[i].quantity, lineItems[i].variant_metafields.max_purchases)
        if(qtyCheck == false) {
          qty = lineItems[i].variant_metafields.max_purchases
        }
      }else if(lineItems[i].metafields.max_purchases) {
        qtyCheck = MikihouseCart.maxPurchases.qtyChecker(lineItems[i].quantity, lineItems[i].metafields.max_purchases)
        if(qtyCheck == false) {
          qty = lineItems[i].metafields.max_purchases
        }
      } else if(outOfStock == true) {
        qtyCheck = MikihouseCart.maxPurchases.qtyChecker(lineItems[i].quantity, lineItems[i].inventory_quantity)
        if(qtyCheck == false) {
          qty = lineItems[i].inventory_quantity
        }
      }
      
      if(qtyCheck == false) {
        variantId = lineItems[i].variant_id
        key = lineItems[i].key
        break
      }
    }
    if(qtyCheck == false) {
      MikihouseCart.cartActions.cartUpdate(variantId, Number(qty), key)
      const url = new URL(window.location);
      url.searchParams.set('max_qty', 'true');
      history.pushState({}, '', url);
    }
  }
},
paramsChecker: () => {
  const target = document.querySelector('#errorModal')
  const url = new URL(window.location)
  if(location.search.match(/max_qty=true/)) {
    /**
    * TODO: 多言語対応
    */
  const language = {
    ja: {
      update: '商品の購入できる最大数量より多くカートに入っていたため、数量を変更しました'
    },
    en: {
      update: 'You had more items in your cart than the maximum quantity available for purchase, so we changed the quantity'
    },
    ko: {
      update: '장바구니에 최대 구매 가능 수량을 초과하여 장바구니에 담겼기 때문에 수량을 변경했습니다.'
    },
    'zh-CN': {
      update: '数量已被更改，因为购物车中的产品数量超过了可购买的最大数量。'
    },
    'zh-TW': {
      update: '數量已更改，因為購物車包含的產品數量超過了可以購買的產品的最大數量。'
    }
  }
    document.querySelector('#errorModal > div.content > div').innerHTML = `<p>${language[Shopify.locale].update}</p>`
    target.classList.remove('hide')
    url.searchParams.delete('max_qty')
    history.pushState({}, '', url)
  }
  document.querySelector('#errorModal .close-btn').addEventListener('click', () => target.classList.add('hide'))
  document.querySelector('#errorModal .bg').addEventListener('click', () => target.classList.add('hide'))
},
qtyChecker: (qty, maxPurchases) => {
  if(qty > maxPurchases) {
    return false
  }
  return true
}
},
novelty: {
cartNoveltyItemRemove: () => {
  const target = document.querySelectorAll('tr[data-cart-novelty-item-flg]')
  for(let i = 0; i < target.length; i++) {
    MikihouseCart.cartActions.cartUpdate(target[i].dataset.cartItemId, 0, target[i].dataset.cartItemKey)
  }
},
noveltyAddToCart: () => {
  return new Promise(async (resolve) => {
    const target = document.querySelectorAll('.noveltycollection-input')
    let array = {}
    for(let i = 0; i < target.length; i++) {
      if(target[i].checked == true && target[i].dataset.noveltyVariantid) {
        array[target[i].dataset.noveltyVariantid] = 1
      }
    }
    const body = {
      'updates': array
    }
    const headers = {
      'method': 'POST',
      'headers': {
        'Content-Type': 'application/json'
      },
      'body': JSON.stringify(body)
    }
    await MikihouseCart.cartActions.fetchCart(window.Shopify.routes.root + 'cart/update.js?sections=cart-template,header', headers, true)
    resolve(true)
  })
}
},
InsertName: {
MikihouseInsertNameCommission: (lineItems) => {
  const insertNameItem = lineItems.filter(e => e.metafields.remarks == '名入れ商品')
  //  const insertNameCommissionItem = lineItems.filter(e => e.tags. == '名入れ商品')
  if(insertNameItem.length > 0) {
    const commissionItem = lineItems.filter(e => e.variant_id == insertNameItem[0].metafields.insert_name.variant_id)
    if(commissionItem.length === 0 ) {
      const addItem = {
        items: []
      }
      addItem['items'] = [
        {
          id: insertNameItem[0].metafields.insert_name.variant_id,
          quantity: 1
        }
      ]
      MikihouseCart.cartActions.cartAdd(addItem, true)
    }
  } else {
    const insertNameCommissionItem = lineItems.filter(e => e.tags.includes('名入れ代'))
    if(insertNameCommissionItem.length > 0) {
      MikihouseCart.InsertName.removeCommitionItem(insertNameCommissionItem[0].variant_id)
    }
  }
},
removeCommitionItem: (variantId) => {
  return new Promise(async (resolve) => {
    const url = window.Shopify.routes.root + 'cart/update.js?sections=cart-template,header'
    const body = {
      'updates': {
        [variantId]: 0
      }
    }
    const headers = {
      'method': 'POST',
      'headers': {
        'Content-Type': 'application/json'
      },
      'body': JSON.stringify(body)
    }
    await MikihouseCart.cartActions.fetchCart(url, headers)
    resolve(true)
  })
}
},
orderDateSet: {
orderDate: () => {
  const nowDate = dayjs()
  const nowTime = nowDate.format();

  let cartAttributes = {
    "order_date": nowTime,
  };

  return fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      attributes: cartAttributes
    })
  })
  .then(response => response.json())
  .then(data => {
    console.log('Cart attributes updated successfully')
  }).catch((error) => {
    console.error('Error:', error);
  })
}
},
outletItem: {
cartOutletItem: (lineItems, loginFlg) => {
  let outletFlg = false
  for(let i = 0; i < lineItems.length; i++) {
    const sellTypeCode = Number(lineItems[i].variant_metafields.sell_type_code)
    if(sellTypeCode === 2) {
      outletFlg = true
      break
    }
  }
  if(outletFlg == true && loginFlg == 'false') {
    const target = document.querySelector('#errorModal')
      /**
      * TODO: 多言語対応
      */
    const language = {
      ja: {
        update: '会員のみ購入できる商品がカートに含まれています。'
      },
      en: {
        update: 'The cart contains items that can only be purchased by members.'
      },
      ko: {
        update: '회원만 구매할 수 있는 상품이 장바구니에 포함되어 있습니다.'
      },
      'zh-CN': {
        update: '购物车包含只有会员才能购买的产品。'
      },
      'zh-TW': {
        update: '您的購物車包含只能由會員購買的產品。'
      }
    }
    document.querySelector('#errorModal > div.content > div').innerHTML = `<p>${language[Shopify.locale].update}</p>`
    target.classList.remove('hide')
    document.querySelector('#errorModal .close-btn').addEventListener('click', () => target.classList.add('hide'))
    document.querySelector('#errorModal .bg').addEventListener('click', () => target.classList.add('hide'))
  }
}
},
quantityChange: {
cartQuantityChange: (lineItems) => {
  const qtyElm = document.querySelectorAll('.cart__qty-input')
  const event = 'change,input'
  for(let i = 0; i < qtyElm.length; i++) {
    qtyElm[i].addEventListener('input', (e) =>  {
      const targetItem = lineItems.filter(lineItem => lineItem.key === e.target.dataset.variantKey)
      let max_purchases = targetItem[0].inventory_quantity
      let outOfStock = true
      if(targetItem[0].inventory_management == '' || targetItem[0].inventory_policy == 'continue') {
        outOfStock = false
        max_purchases = 100000 // ここは注文できない数字にしてあります
      }
      if(targetItem[0].variant_metafields.max_purchases) {
        max_purchases = targetItem[0].variant_metafields.max_purchases
      } else if(targetItem[0].metafields.max_purchases) {
        max_purchases = targetItem[0].metafields.max_purchases
      }
      console.log(e.target.classList.contains('pc-qty'))
      let qty = 0
      if(e.target.classList.contains('pc-qty')) {
        const quantities = document.querySelectorAll('.cart__qty-input.pc-qty')  
        for(let target of quantities) {
          qty += parseInt(target.value)
        }
      } else {
         const quantities = document.querySelectorAll('.cart__qty-input.sp-qty')  
        for(let target of quantities) {
          qty += parseInt(target.value)
        }
      }
      
      console.log(qty)
      

      
      if(Number(e.target.value) > max_purchases) {
        const target = document.querySelector('#errorModal')
        /**
          * TODO: 多言語対応
          */
        const language = {
          ja: {
            error: '在庫以上または最大購入数以上の注文はできません'
          },
          en: {
            error: 'The cart contains items that can only be purchased by members.'
          },
          ko: {
            error: '회원만 구매할 수 있는 상품이 장바구니에 포함되어 있습니다.'
          },
          'zh-CN': {
            error: '购物车包含只有会员才能购买的产品。'
          },
          'zh-TW': {
            error: '您的購物車包含只能由會員購買的產品。'
          }
        }
        document.querySelector('#errorModal > div.content > div').innerHTML = `<p>${language[Shopify.locale].error}</p>`
        target.classList.remove('hide')
        e.target.value = max_purchases
        document.querySelector('#errorModal .close-btn').addEventListener('click', () => target.classList.add('hide'))
        document.querySelector('#errorModal .bg').addEventListener('click', () => target.classList.add('hide'))
        return true
      }
      let monitorItemCount 
      if(e.target.dataset.monitorFlg == 'true' && parseInt(e.target.dataset.monitorMax) < qty && parseInt(e.target.dataset.monitorMax) > 0) {
        const target = document.querySelector('#errorModal')
        const language = {
          ja: {
            error: `対象商品は一回のご注文で${e.target.dataset.monitorMax}点までご購入頂けます。`
          },
          en: {
            error: `You can purchase up to ${e.target.dataset.monitorMax} items in a single order.`
          },
          ko: {
            error: `대상 상품은 1회 주문으로 ${e.target.dataset.monitorMax}점까지 구입하실 수 있습니다.`
          },
          'zh-CN': {
            error: `您可以在一个订单中购买最多 ${e.target.dataset.monitorMax} 件商品。`
          },
          'zh-TW': {
            error: `您可以在一個訂單中購買最多 ${e.target.dataset.monitorMax} 件商品。`
          }
        }
        document.querySelector('#errorModal > div.content > div').innerHTML = `<p>${language[Shopify.locale].error}</p>`
        target.classList.remove('hide')
        console.log(lineItems)
        e.target.value = targetItem[0].quantity
        document.querySelector('#errorModal .close-btn').addEventListener('click', () => target.classList.add('hide'))
        document.querySelector('#errorModal .bg').addEventListener('click', () => target.classList.add('hide'))
        return true
      }
      if(e.target.value !== '') {
        MikihouseCart.cartActions.cartUpdate(e.target.dataset.variantId, Number(e.target.value), e.target.dataset.variantKey)
      }
    })
  }
}
},
shippingDate: {
expectedShipmentDate: () => {
  const sippingDate = document.querySelector('#sippingDate');
  for(let i = 0; i < Array.from(sippingDate.options).length;i++) {
    if(sippingDate.options[i].selected == true) {
      const expectedShipmentDateElm = document.querySelector('#expectedShipmentDate')
      expectedShipmentDateElm.value = sippingDate.options[i].dataset.shippingDate
    }
  }
  return true
}
}
}